import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import bannerData from "../../data/banner/banner-one.json";
import BannerOneSingle from "../../components/banner/BannerOneSingle.js";
import { AuthContext } from "../../common/Auth"
import CategoryEditIcon from "../../pages/categorySection/CategoryEditIcon"
import Swiper from "react-id-swiper";
import useWindowSize from "../../util/custom-hooks/useWindowSize";

const BannerOne = () => {
  const { themeSettingsData, categoriesList } = useContext(AuthContext)
  let getData = []
  const [windowWidth] = useWindowSize()

  let dynamicBannerData = null
  if (themeSettingsData && themeSettingsData.length > 0) {
    themeSettingsData.map((dataArray) => {
      if (dataArray.settingsName == 'categorySection') {
        dynamicBannerData = dataArray.values[0];
        
        categoriesList.forEach(category => {
          let categoryName = category.categoryName.toLowerCase();
          if(categoryName === dynamicBannerData?.firstCatLink?.toLowerCase()) {
            dynamicBannerData.firstCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.secondCatLink?.toLowerCase()) {
            dynamicBannerData.secondCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.thirdCatLink?.toLowerCase()) {
            dynamicBannerData.thirdCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.fourthCatLink?.toLowerCase()) {
            dynamicBannerData.fourthCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.fifthCatLink?.toLowerCase()) {
            dynamicBannerData.fifthCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.sixthCatLink?.toLowerCase()) {
            dynamicBannerData.sixthCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.seventhCatLink?.toLowerCase()) {
            dynamicBannerData.seventhCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.eightCatLink?.toLowerCase()) {
            dynamicBannerData.eightCatLink = category.categoryName;
          }
          if(categoryName === dynamicBannerData?.nineCatLink?.toLowerCase()) {
            dynamicBannerData.nineCatLink = category.categoryName;
          }
        })
      }
    })
  }


  let pt = dynamicBannerData?.paddingTop ? dynamicBannerData.paddingTop : 'pt-0'
  let pb = dynamicBannerData?.paddingBottom
    ? dynamicBannerData.paddingBottom
    : 'pb-0'
  let mb = dynamicBannerData?.marginBottom
    ? dynamicBannerData.marginBottom
    : 'mt-30'
  let mt = dynamicBannerData?.marginTop ? dynamicBannerData.marginTop : 'mb-30'
  let mr = dynamicBannerData?.marginRight
    ? dynamicBannerData.marginRight
    : 'mr-0'
  let ml = dynamicBannerData?.marginLeft ? dynamicBannerData.marginLeft : 'ml-0'
  let pl = dynamicBannerData?.paddingLeft
    ? dynamicBannerData.paddingLeft
    : 'pl-0'
  let pr = dynamicBannerData?.paddingRight
    ? dynamicBannerData.paddingRight
    : 'pr-0'
  let fullSection = dynamicBannerData?.fullSection
    ? 'container-fluid'
    : 'container'
  let bgImage = dynamicBannerData?.bgImage ? dynamicBannerData.bgImage : ''
  let bgColor = dynamicBannerData?.bgColor ? dynamicBannerData?.bgColor : "";
  let zoomInAnimation = dynamicBannerData?.zoomInAnimation ? dynamicBannerData?.zoomInAnimation : "";
  let catScroll = dynamicBannerData?.pageScroll ? dynamicBannerData?.pageScroll : false;
  let catListData = dynamicBannerData?.catList ? dynamicBannerData?.catList : "";
  let automaticSlider = dynamicBannerData?.automaticSlider == undefined ? true  : dynamicBannerData?.automaticSlider

  let chunkSize = dynamicBannerData?.catGridView === true ? 6 : 5;
  
  if(catListData && catListData.length){
    for (let i = 0; i < catListData.length; i += chunkSize) {
      const chunk = catListData.slice(i, i + chunkSize);
      getData.push(chunk);
    }
  }

  let getAutoSlider = automaticSlider ? { delay: 7000,disableOnInteraction: false,} : false
  const settings = {
    loop: false,
    spaceBetween: 0,
    autoplay: getAutoSlider,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },
      320: {
        slidesPerView: 1,
      },
    },
    containerClass:"swiper-container custom-swiper-container",
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    renderPrevButton: () => (
      <>
         <button id="catPrev" className="antera-swiper-button swiper-button-prev ht-swiper-button-nav">
            <i className="pe-7s-angle-left" />
          </button>
      </>
    ),
    renderNextButton: () => (
      <>
       <button id="catNext" className="antera-swiper-button swiper-button-next ht-swiper-button-nav">
            <i className="pe-7s-angle-right" />
          </button>
      </>
    ),
  }

  return (
    <div
      className={`antera-categories-section-container banner-area section-bgImage category-section-container ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr} `}
      style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
    >
      <div className={`${fullSection}`}>
        <div className="edit-inline">
          <CategoryEditIcon editType="mainSettings" />
        </div>
        {catScroll === true ? 
        <div style={{ position: "relative", width: "100%" }}>
            {getData && getData.length > 0 && windowWidth > 991 &&
              <Swiper {...settings}>
                {getData && getData.map((itemData, index) => {
                  return (
                    <div key={index} className={`antera-categories-content-container ${dynamicBannerData?.catGridView === true ? 'gridViewActive' : ""}`}>
                      {itemData && itemData.map((item, index1) => {
                        return (
                          <BannerOneSingle
                            data={{
                              id: index1,
                              image: item.catImage,
                              title: item.catMainText,
                              subtitle: item.catText,
                              price: item.catPriceText,
                              link: item.catLink,
                            }}
                            dynamicBannerData={dynamicBannerData}
                            spaceBottomClass="mb-30"
                            key={index1}
                          />
                        )
                      })}</div>
                  )
                })}
              </Swiper>
            }

            {/* for mobile view */}
            {
              catListData && windowWidth <= 991 && <Swiper {...settings}>
                {
                  catListData && catListData.map((item, index) => {
                    return <div><BannerOneSingle
                      data={{
                        id: index,
                        image: item.catImage,
                        title: item.catMainText,
                        subtitle: item.catText,
                        price: item.catPriceText,
                        link: item.catLink,
                      }}
                      dynamicBannerData={dynamicBannerData}
                      spaceBottomClass="mb-30"
                      key={index}
                    /></div>
                  })
                }
              </Swiper>

            }

            {catListData && catListData.length > 6 && <>
              <label className="custome-swiper-btn swiper-button-prev1" htmlFor="catPrev"><i className="pe-7s-angle-left"></i></label>
              <label className="custome-swiper-btn swiper-button-next1" htmlFor="catNext"><i className="pe-7s-angle-right"></i></label>
            </>
            }
        </div>
        : <>
        {dynamicBannerData && (
          <div
            className={`row inner-category justify-content-center text-center ${dynamicBannerData?.catGridView === true ? 'gridViewActive' : ""}`} style={{ flexWrap: "nowrap" }}
          >
            {
              catListData && catListData.length > 0 && catListData.map((item, index) => {
                return (
                  <BannerOneSingle
                    key={index}
                    data={{
                      id: index,
                      image: item.catImage,
                      title: item.catMainText,
                      subtitle: item.catText,
                      price: item.catPriceText,
                      link: item.catLink,
                    }}
                    dynamicBannerData={dynamicBannerData}
                    spaceBottomClass="mb-30"
                  />
                )
              })
            }
          </div>
        )} </>
      }
      </div>
    </div>
  )
};

BannerOne.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default BannerOne;
